import { Logger } from '@mrkt/features/Platform';
import { webgateFetch } from '@mrkt/features/webgate-fetch';

import { useCurrentArtistIdOrNull } from '../../../artists';
import { fundraisingServiceUrl } from './constants';

async function _delete(artistId: string) {
  const endpoint = `${fundraisingServiceUrl}/v1/artist/${artistId}`;

  try {
    return await webgateFetch(endpoint, {
      method: 'delete',
    });
  } catch (e) {
    Logger.logError('artist-fundraising-pick-put-error', e);
    return null;
  }
}

export function useDelete() {
  const artistId = useCurrentArtistIdOrNull();

  return async function del() {
    if (artistId) {
      return await _delete(artistId);
    }

    return null;
  };
}
